module.exports = __webpack_public_path__ + "img/image-15.0b2dfc49.svg";